<template>
  <div
    v-if="isreply"
    class="comment-reply-content"
    :style="contentStyle"
  >
    <div class="comment-reply-content-item">
      <div
        class="comment-user"
        :style="
        userdetailList.avatar
          ? { 'background-image': `url(${userdetailList.avatar})` }
          : { 'background-image': `url(${defaultAvatar()})` }"
      ></div>
      <el-input
        class="comment-reply-input"
        type="textarea"
        maxlength="512"
        show-word-limit
        v-model="comment"
        placeholder="友善的评论，良性的表达，用发现美的眼睛看世界。"
      ></el-input>
    </div>
    <div class="comment-reply-release">
      <el-button
        class="comment-reply-release-button"
        type="primary"
        v-if="isreply"
        @click="replyRelease"
      >发布</el-button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "CommentContent",
  data() {
    return {
      comment: ""
    };
  },
  watch: {
    comment: function(value) {
      this.$emit("commentContent", this.comment);
    }
  },
  computed: {
    ...mapState("PersonalStore", ["userdetailList"])
  },
  props: {
    isreply: {
      type: Boolean,
      default: false
    },
    ishot: {
      type: Number
    },
    //当前评论对象
    contents: {
      type: Object
    },
    contentStyle:{
      type: String
    }
  },
  methods: {
    replyRelease() {
      this.$emit("replyRelease");
      this.$nextTick(() => {
        this.comment = "";
      })
    },
    defaultAvatar() {
      return import("@/assets/images/person/avatar-default.png");
    },
  }
};
</script>
<style lang="less">
.comment-reply-content {
  display: flex;
  -ms-flex-pack: justify;
  flex-direction: column;
  .comment-reply-content-item {
    display: flex;
  }
  /* 评论用户头像部分 */
  .comment-user {
    width: 51px;
    height: 51px;
    border-radius: 30px;
    background-size: 100% 100%;
    //默认背景
    background-image: url("~@/assets/images/travel/avatar-default.png");
    // 空间不足的时候不做压缩
    flex-shrink: 0;
  }
  .comment-reply-input.el-textarea {
    margin-left: 20px;
    textarea {
      height: 98px;
    }
  }
  .comment-reply-release {
    .comment-reply-release-button {
      width: 148px;
      height: 42px;
      background-color: #57dec1;
      border-radius: 4px;
      float: right;
      margin-top: 13px;
      color: #ffffff;
    }
  }
}
</style>
